import { React, useState, useEffect } from "react";

import axios from "axios";

import ScanContainerScreen from "./Components/ScanContainerScreen";
import ContainerScanned from "./Components/ContainerScanned";

import PackageNotFound from "./Components/PackageNotFound";
import PackageNotForVenue from "./Components/PackageNotForVenue";
import PackageAlreadyScanned from "./Components/PackageAlreadyScanned";
import GenericErrorScreen from "./Components/GenericErrorScreen";
import ServerErrorScreen from "./Components/ServerErrorScreen";

import DecomFinishPage from "./Components/DecomFinishPage";

import FinishBell from "./Sounds/FinishBell.mp3";
import Error from "./Sounds/error.mp3";
import useSound from "use-sound";

function Decomission({ goHome }) {
  const [packageData, setPackageData] = useState([]);
  const [activePage, setActivePage] = useState("ScanPackagePage");

  const token = localStorage.getItem("token");

  const [playFinish] = useSound(FinishBell);
  const [playError] = useSound(Error);

  useEffect(() => {
    window.history.scrollRestoration = "manual";
  }, []);

  useEffect(() => {
    if (activePage === "Finish") {
      finish();
    }
  }, [activePage]);

  const packageArray = (e) => {
    setPackageData((packageData) => [...packageData, e]);
  };

  const setFinishPage = () => {
    handleSubmit();
  };

  const backToScanPackage = () => {
    setActivePage("ScanPackagePage");
  };

  const activateScannedPage = () => {
    setActivePage("PackageScanned");
    setTimeout(() => {
      setActivePage("ScanPackagePage");
    }, 800);
  };

  const finish = () => {
    setTimeout(() => {
      setPackageData([]);
      goHome();
    }, 2000);
  };

  const handleSubmit = async () => {
    const loginFormData = {
      packagingItems: [...new Set(packageData)],
    };

    try {
      const response = await axios({
        method: "post",
        url: "https://api.venuenow.tech/packaging-transaction/catering/decommission",
        data: loginFormData,
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      });
      console.log(response);
      if (response.data.statusCode === 201) {
        playFinish();
        setActivePage("Finish");
      }
      if (response.data.statusCode === 500) {
        setActivePage("PackageNotForVenue");
        playError();
      }
    } catch (error) {
      let errorStatusResult = error.response.status.toString();
      const startsWithFive = errorStatusResult.startsWith("5");

      if (errorStatusResult === "404") {
        setActivePage("PackageNotFound");
        playError();
      } else if (errorStatusResult === "409") {
        setActivePage("PackageAlreadyScanned");
        playError();
      } else if (startsWithFive) {
        setActivePage("ServerErrorScreen");
        playError();
      } else {
        setActivePage("GenericErrorScreen");
        playError();
      }
    }
  };

  return (
    <form className="body">
      {activePage === "ScanPackagePage" && (
        <ScanContainerScreen
          setPackageData={packageArray}
          setActivePage={activateScannedPage}
          finish={setFinishPage}
        />
      )}

      {activePage === "PackageScanned" && (
        <ContainerScanned
          backToScan={backToScanPackage}
          finish={setFinishPage}
        />
      )}

      {activePage === "PackageNotFound" && (
        <PackageNotFound backToScan={goHome} />
      )}
      {activePage === "PackageNotForVenue" && (
        <PackageNotForVenue backToScan={goHome} />
      )}
      {activePage === "PackageAlreadyScanned" && (
        <PackageAlreadyScanned backToScan={goHome} />
      )}
      {activePage === "GenericErrorScreen" && (
        <GenericErrorScreen backToScan={goHome} />
      )}
      {activePage === "ServerErrorScreen" && (
        <ServerErrorScreen backToScan={goHome} />
      )}

      {activePage === "Finish" && <DecomFinishPage />}
    </form>
  );
}

export default Decomission;
